@if (loadingMessages) {
  <div class="chat_row">
    <mat-progress-bar mode="indeterminate" [style]="{ height: '6px' }"></mat-progress-bar>
  </div>
} @else if (thread) {
  <div class="chat_container">
    @if (!thread.messages.length) {
      <div class="chat_row">
        <div class="chat_message admin">Start the conversation by entering a message below</div>
      </div>
    }
    @for (item of thread.messages; track $index) {
      <div class="chat_row">
        @if (!isMessageSender(item) && item.senderName) {
          <div class="sender-name">{{ item.senderName }}</div>
        }
        <div [matTooltip]="getFormattedTime(item.dateSent)" [class]="getMessageClass(item)">
          <span
            [innerHTML]="escapeHtml(item.message) | chat: getMessageClass(item) === 'chat_message right' ? 'chat_link_blue' : 'chat_link_white'"></span>
        </div>
      </div>
    }
    @if (thread.messages.length) {
      <div class="chat_row chat_date">
        {{ getFormattedTime(thread.messages[thread.messages.length - 1].dateSent) }}
      </div>
    }
  </div>
}


